import { filter } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

enum SideNavState {
    Opened,
    Closed
}

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
    animations: [
        trigger('menuButtonState', [
            state(
                'visible',
                style({
                    transform: 'scale(1) rotate(0deg)',
                    opacity: '1'
                })
            ),
            state(
                'hidden',
                style({
                    transform: 'scale(0) rotate(180deg)',
                    opacity: '0'
                })
            ),
            transition('* <=> *', animate('200ms ease-out'))
        ])
    ]
})
export class HeaderComponent implements OnInit {
    _sideNavState: SideNavState;
    closeIconState: string;
    menuIconState: string;
    mobileTitle: string;
    @Input() sidenav: MatSidenav;
    @Output() mayEditTextComponentEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    static getCurrentRouteMobileTitle(route: ActivatedRoute): string {
        const mobileTitle = '';
        let currentRoute = route;
        while (currentRoute.children.length > 0) {
            currentRoute = currentRoute.children[0];
        }

        return currentRoute.snapshot.data['mobileTitle'];
    }

    get sideNavState(): SideNavState {
        return this._sideNavState;
    }

    set sideNavState(value: SideNavState) {
        this._sideNavState = value;
        if (this._sideNavState === SideNavState.Closed) {
            this.menuIconState = 'visible';
            this.closeIconState = 'hidden';
        } else if (this._sideNavState === SideNavState.Opened) {
            this.menuIconState = 'hidden';
            this.closeIconState = 'visible';
        }
    }

    constructor(public router: Router, public route: ActivatedRoute) {
        //
    }

    ngOnInit(): void {
        this.sidenav.openedStart.subscribe(() => this.onSidenavOpening(this));
        this.sidenav.closedStart.subscribe(() => this.onSidenavClosing(this));

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
            this.mobileTitle = HeaderComponent.getCurrentRouteMobileTitle(this.route);
        });

        this.sideNavState = SideNavState.Closed;
    }

    onSidenavClosing(self: HeaderComponent): void {
        self.sideNavState = SideNavState.Closed;
    }

    onSidenavOpening(self: HeaderComponent): void {
        self.sideNavState = SideNavState.Opened;
    }

    toggleSideNav(): void {
        this.sidenav.toggle();
    }

    textComponentEvent($event: boolean) {
        this.mayEditTextComponentEvent.emit($event);
    }
}
